var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["home-goods-topic border-radius-8"], style: _vm.customStyle },
    [
      _vm.isShowBannerImgColor
        ? _c(
            "div",
            { staticClass: "bg-img-class" },
            [
              _c("lazy-img", {
                attrs: {
                  src: _vm.blurTopBanner,
                  width: "100%",
                  height: "100%",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "topic-title" }, [
        _c("div", [_vm._v(_vm._s(_vm.topicName))]),
        _vm._v(" "),
        _c("div", { staticClass: "to-more-goods", on: { click: _vm.toMore } }, [
          _vm._v("\n      更多\n      "),
          _c("img", {
            attrs: { src: require("../../../../image/home/home-to-more.png") },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "topic-banner", on: { click: _vm.bannerJump } },
        [
          _c("lazy-img", {
            attrs: { src: _vm.topicBanner, width: "100%", height: "100%" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "topic-goods" },
        _vm._l(_vm.goodsFormat, function (goods, index) {
          return _c(
            "div",
            {
              key: goods.productId,
              staticClass: "topic-goods-item border-radius-8",
              on: {
                click: function ($event) {
                  return _vm.toProductDetail(goods.href)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "img-wrap" },
                [
                  _c("img", {
                    staticClass: "rapidAfterSales-image",
                    attrs: { src: goods.rapidAfterSalesImage },
                  }),
                  _vm._v(" "),
                  _c("isSoldout", {
                    attrs: {
                      isSold: goods.totalInventory == 0,
                      src: goods.imgUrl,
                      alt: "",
                      width: "29.7vw",
                      height: "29.7vw",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "labels" },
                    _vm._l(goods.commonLabel, function (l, i) {
                      return i < 2
                        ? _c(
                            "div",
                            {
                              key: i,
                              staticClass: "item-common-label",
                              style: `background-color:${l.labelColor}`,
                            },
                            [_vm._v(_vm._s(l.title))]
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                  _vm._v(" "),
                  goods.labels && goods.labels.buyerShow
                    ? _c("div", { staticClass: "buyer-label" }, [
                        _vm._v(_vm._s(goods.labels.buyerShow)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "goods-master-name padding-lr-5" }, [
                goods.countryImage
                  ? _c("span", [
                      _c("img", {
                        staticClass: "country-image-label",
                        attrs: { src: goods.countryImage },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                goods.hasVideo == 1
                  ? _c("span", [
                      _c("img", {
                        staticClass: "country-image-label",
                        attrs: {
                          src: require("../../../../image/buyer/iconPlay.png"),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v("\n        " + _vm._s(goods.masterName) + "\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "goods-price padding-lr-5" },
                [
                  _c("price", {
                    staticClass: "goods-master-price",
                    style: { marginRight: "2px" },
                    attrs: {
                      originPrice: goods.price,
                      intSize: "14",
                      fracSize: "9",
                    },
                  }),
                  _vm._v(" "),
                  !(
                    (!goods.groupPrice || goods.groupPrice == 0) &&
                    goods.marketPrice != 0 &&
                    goods.marketPrice > goods.price
                  )
                    ? _c("br")
                    : _vm._e(),
                  _vm._v(" "),
                  (!goods.groupPrice || goods.groupPrice == 0) &&
                  goods.marketPrice != 0 &&
                  goods.marketPrice > goods.price
                    ? _c("price", {
                        staticClass: "goods-market-price",
                        attrs: {
                          originPrice: goods.marketPrice,
                          intSize: "11",
                          fracSize: "10",
                          color: "rgb(189, 192, 197)",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("price", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !!goods.groupPrice,
                        expression: "!!goods.groupPrice",
                      },
                    ],
                    staticClass: "goods-master-price",
                    attrs: {
                      originPrice: goods.groupPrice,
                      intSize: "12",
                      fracSize: "12",
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !!goods.groupPrice,
                        expression: "!!goods.groupPrice",
                      },
                    ],
                    staticClass: "pintuan_img",
                    attrs: {
                      src: require("../../../../image/global/pintuan.png"),
                      alt: "拼团图片",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }